import { Component, OnInit } from '@angular/core';
import { userTipeLTI } from '../../../model/lti-launch';
import { LtiLaunchComponent } from '../lti-launch/lti-launch.component';

@Component({
  selector: 'app-launchSupervisor',
  templateUrl: '../lti-launch/lti-launch.component.html'
})
export class LaunchSupervisorComponent extends LtiLaunchComponent implements OnInit {

  ngOnInit() {
    this.startLaunch();
  }

  startLaunch(): void {
    this.loadClassConfiguration(userTipeLTI.SUPERVISOR);
    this.generateParams();
    this.loadInputFields();
    this.submitForm();
  }

}
